export default "__VITE_ASSET__BAhcWhXe__"